import { useExternalToken as useSharedExternalToken } from '@sib/api';
import { useUserSetupStore } from '@sib/auth';

export const useExternalToken = () => {
  const organizationId = useUserSetupStore(state => state.organization.id);

  return useSharedExternalToken(organizationId);
};
